export default __webpack_public_path__ + "static/media/flag-pt-BR.6dbb9874.svg";